import { __awaiter, __generator } from "tslib";
import { fetchOfficeComponentContext } from '@office-start/component-context-service';
import { getHarmonyBuildId } from '../util/getHarmonyBuildId';
export var fetchHarmonyBuildId = (function () {
    var buildId;
    return function () { return __awaiter(void 0, void 0, void 0, function () {
        var componentContext;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (buildId !== undefined) {
                        return [2 /*return*/, buildId];
                    }
                    return [4 /*yield*/, fetchOfficeComponentContext()];
                case 1:
                    componentContext = _a.sent();
                    buildId = getHarmonyBuildId(componentContext);
                    return [2 /*return*/, buildId];
            }
        });
    }); };
})();
//# sourceMappingURL=fetchHarmonyBuildId.js.map